<div class="container" *transloco="let t">
  <div class="row">
    <div class="col-md-8 p-2">
      @if(!isAnythingLoading() && !paginatedDeliveries?.data.length){
        <div class="info-box mt-2">
          <div class="info-box-icon">
            <i class="fa-solid fa-circle-info"></i>
          </div>
          <p>
            <span class="font-weight-bold">{{ t('common.no_results') }}</span><br>
            <span>{{ t('common.try_removing_or_changing_filters') }}</span>
          </p>
        </div>
      }
      @if (loadingObject.initialData) {
        <multisite-loader-globe-animation-detail
          [width]="100"
          [height]="100"
        ></multisite-loader-globe-animation-detail>
      }

      <div class="d-flex flex-column gap-2">
        @for (delivery of paginatedDeliveries?.data; track delivery) {
          <multisite-delivery-status-card
            [delivery]="delivery"
            (selected)="gotoDelivery($event)"
            [showCredits]="hasRole('Admin')"
          ></multisite-delivery-status-card>
        }
      </div>

      <div class="my-3">
        @if (
          paginatedDeliveries?.meta && paginatedDeliveries.meta.last_page > 1
          ) {
          <frontend-pagination-type-three
            [classes]="'pg-purple justify-content-center'"
            [loading]="isAnythingLoading()"
            [meta]="paginatedDeliveries.meta"
            [lastPage]="paginatedDeliveries.meta.last_page"
            [links]="paginatedDeliveries.links"
            (changePage)="doGetPaginatedDeliveries($event, false)"
          ></frontend-pagination-type-three>
        }
      </div>
    </div>
    <div class="col-md-4 p-2">
      <!-- Contributions Filters Component -->
      <multisite-contributions-filters
        [paginatedDeliveries]="paginatedDeliveries"
        [cultures]="nationalCultures()"
        (changePage)="doGetPaginatedDeliveries($event)"
        [loading]="loadingObject['initialData']"
        [initialFilters]="queryParams().filters"
        [initialOptions]="queryParams().options"
        (filtersChange)="onFiltersChange($event)"
        (optionsChange)="onOptionsChange($event)"
      ></multisite-contributions-filters>

      @if(hasRole('Admin')){
        <div class="d-flex align-items-center flex-wrap gap-1 w-100 mt-3">
          <multisite-score-highlight
            class="flex-grow-1"
            [titleText]="'Credits'"
            [iconClasses]="'fa-solid fa-coins'"
            [score]="20000"
          ></multisite-score-highlight>
          <multisite-score-highlight
            class="flex-grow-1"
            [titleText]="'Tasks'"
            [iconClasses]="'fa-solid fa-square-check'"
            [score]="16"
            [denominator]="52"
            [rgbColourVariable]="'var(--bs-success-rgb)'"
          ></multisite-score-highlight>
        </div>
      }
      @if(hasRole('Admin')){
        @for (link of links; track link) {
          <multisite-link-type-six
            [imageTransformations]="'w_100,c_thumb/'"
            [titleText]="link.label"
            [description]="link.description"
            [image]="link.image"
            [cta_label]="link.cta_label"
            [cta_type]="link.cta_type"
            [url]="link.url"
          ></multisite-link-type-six>
        }
      }
    </div>
  </div>
</div>
